























import {
  defineComponent,
  ref,
  useContext,
} from "@nuxtjs/composition-api";
import { isEmpty, clone, map } from "lodash-es";
import DesktopMenuItem from "./components/desktop/MenuItem.vue";
import MobileMenuList from "./components/mobile/MenuList.vue";

export default defineComponent({
  name: "HeaderTopMenu",
  components: {
    DesktopMenuItem,
    MobileMenuList,
  },
  props: {
    menuTree: {
      type: Array,
      default: () => [],
    },
    isShowNav: {
      type: Boolean,
    },
    toHideNav: {
      type: Array,
      default: () => [],
    },
  },
  setup(props, { emit }) {
    const {
      app: { i18n },
    } = useContext();
    const desktopMenuList = ref([]);
    const mobileMenuList = ref([]);
    const historyMenu = ref([]);
    const isShowNav = ref(props.isShowNav);

    if (isEmpty(desktopMenuList.value)) {
      mobileMenuList.value = desktopMenuList.value = map(props.menuTree, (item) => {
        if (item["url_key"] === "products-applications") {
          item["children"] = [
            {
              title: i18n.t("Markets"),
              children: item["children"],
            },
            {
              title: i18n.t("Our core competencies"),
              url_key: "products-applications/our-core-competencies"
            }
          ];
        }
        return item;
      });
    }

    const toNextMenu = (menu) => {
      historyMenu.value.push(menu);
      mobileMenuList.value = menu.children;
    };
    const toPrevMenu = () => {
      historyMenu.value.pop();
      const menu = clone(historyMenu.value).pop();
      mobileMenuList.value = menu ? menu.children : props.menuTree;
    };
    const closeNav = () => {
      if (!isShowNav.value) {
        emit("toHideNav", isShowNav.value);
      }
    };
    return {
      desktopMenuList,
      mobileMenuList,
      historyMenu,
      toPrevMenu,
      toNextMenu,
      closeNav,
    };
  },
});
